module.exports = __webpack_public_path__ + "63e13c32ab08e888b8ca3d25b1241927.svg";